import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import governmentLogo from "../../../images/Logo/GOB.png";
import USAID from "../../../images/Logo/USAID-Logo.png";
import BARCLogo from "../../../images/Logo/BARC.jpg";
import bracLogo from "../../../images/Logo/brack.png";
import "../../../style/donors/pastDonor.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const PastDonors = () => {
  useEffect(() => {
    document.title = `Development Concern | Past Donor`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/donors/past-donors";

  return (
    <div>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="past_donor_section">
        <div className="header_image">
          <p>Home | Donor</p>
          <h2>Past Donor</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Past Donors</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Our Past Donors</h1>
          <div className="content_wrapper">
            <Zoom duration={2000}>
              <div className="singal_wrapper">
                <img src={governmentLogo} alt="" />
                <p>Ministry of Health</p>
              </div>
            </Zoom>

            <Zoom duration={2000}>
              <div className="singal_wrapper">
                <img src={BARCLogo} alt="" />
                <p>BARC</p>
              </div>
            </Zoom>
            {/* 
            <Zoom duration={2000}>
              <div className="singal_wrapper">
                <img src={USAID} alt="" />
                <p>USAID</p>
              </div>
            </Zoom>

            <Zoom duration={2000}>
              <div className="singal_wrapper">
                <img src={bracLogo} alt="" />
                <p>BRAC</p>
              </div>
            </Zoom> */}

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PastDonors;
